import { AppComponent } from '@core/components/app/app.component';
import { appConfig } from '@app/app.config';
import { environment } from '@environments/environment';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { RsSentry } from '@lib/utils/rs-senty-init';

new RsSentry({
  dsn: 'https://ca2f68b0be0f49b89120618a5041e48a@o268277.ingest.sentry.io/5469054',
  enabled: environment.enableSentryMonitoring,
  environment: environment.environment,
  sentryReleaseName: environment.sentryReleaseName
}).sentryInit();

Sentry.getCurrentScope().setTag('app.name', 'MRT');
Sentry.getCurrentScope().setTag('app.environment', environment.environment as string);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
